<script>
  let { content } = $props();
</script>

{#if content}
  <div class="bg-gray-mercury">
    <div class="markdown-wrapper text-sm max-w-6xl mx-auto py-3 px-4">
      {@html content}
    </div>
  </div>
{/if}
